var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8707 12.4359C24.8707 19.3037 19.3032 24.8712 12.4354 24.8712C5.5675 24.8712 0 19.3037 0 12.4359C0 5.56799 5.5675 0.000488281 12.4354 0.000488281C19.3032 0.000488281 24.8707 5.56799 24.8707 12.4359ZM1.50585 12.4359C1.50585 18.4721 6.39916 23.3654 12.4354 23.3654C18.4716 23.3654 23.3649 18.4721 23.3649 12.4359C23.3649 6.39965 18.4716 1.50634 12.4354 1.50634C6.39916 1.50634 1.50585 6.39965 1.50585 12.4359Z",
    fill: "#001B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9504 12.9474C18.1604 12.8261 18.1604 12.5231 17.9504 12.4019L10.2736 7.96967C10.0637 7.84845 9.80123 7.99997 9.80123 8.24242V17.1068C9.80123 17.3493 10.0637 17.5008 10.2736 17.3796L17.9504 12.9474Z",
    fill: "#001B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.b23e9b1003004c21736e0e215569e6e8.svg";
export { ForwardRef as ReactComponent };